module.exports = __webpack_public_path__ + "static/goals_enterprener_art@2x-51f465ca148081a213a8a36ca880cb79.png";